/**
 * Created by staffanrantzow on 17/10/16.
 */

import React, { PropTypes } from 'react';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';

class ToolTip extends React.Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
    buttonClasses: PropTypes.string
  };

  static defaultProps = {
    buttonClasses: 'tooltip-info-button'
  };

  constructor (props) {
    super(props);

    this.getToolTip = this.getToolTip.bind(this);
    this.manualHide = this.manualHide.bind(this);
  }

  manualHide (event) {
    this.refs['overlay-trigger'].hide();
  }

  getToolTip () {
    return (
      <Tooltip id={'tt-' + this.props.id} bsClass='info-tooltip'>
        <button className='close' onClick={this.manualHide}></button>
        {this.props.msg}
      </Tooltip>
    );
  }

  render () {
    return (
      <OverlayTrigger placement='bottom' ref='overlay-trigger' trigger={['hover', 'focus']} overlay={this.getToolTip()}>
        <button type='button' className={this.props.buttonClasses} tabIndex={-1} />
      </OverlayTrigger>
    );
  }
}

export default ToolTip;



/** WEBPACK FOOTER **
 ** ./src/components/tooltip/tooltip.js
 **/